import {ApiClientInterface} from "./clients";
import {
  EntrepreneurIdentification, Identification,
  IndividualIdentification,
  LegalEntityIdentification,
  LegalEntityIdentificationBorrower,
  UuidResult
} from "./models";
import {Role} from "./enums";

export class IdentificationManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public findOne():Promise<Identification>
  {
    return this.apiClient.get("/");
  }

  public createIndividualIdentification(
    identification: IndividualIdentification
  ): Promise<UuidResult> {
    return this.apiClient.post("/individual", {identification});
  }

  public createLegalEntityIdentification(
    identification: LegalEntityIdentification | LegalEntityIdentificationBorrower, role: Role
  ): Promise<UuidResult> {
    return this.apiClient.post("/legal-entity", {identification, role});
  }

  public createEntrepreneurIdentification(
    identification: EntrepreneurIdentification
  ): Promise<UuidResult> {
    return this.apiClient.post("/entrepreneur", {identification});
  }
  public confirm(
    confirmationUuid: string, code: string
  ): Promise<void> {
    return this.apiClient.post("/confirm", {confirmationUuid, code});
  }
}

export default IdentificationManager;